import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import { api } from '../api';
import SelectColaborador from '../components/SelectColaborador';
import ModalConfirmar from '../components/ModalConfirmar';
import PainelLancamentos from '../components/PainelLancamentos';
import { ModalDemanda, ModalDesfechoDemanda, urgencia } from './Demandas';
import AgendarMensagemCliente from '../components/AgendarMensagemCliente';
import HistoricoMensagens from '../components/HistoricoMensagens';

const PROCESSO_VAZIO = {
  numero_processo: '', nome_marca: '', situacao: '', apresentacao: '',
  natureza: '', classes: '', deposito: '', concessao: '', vencimento: '',
  titular: '', procurador: '',
};

const CAMPOS_PROCESSO = [
  { name: 'numero_processo', label: 'Número do Processo', placeholder: 'Ex: 935613161', col: 1 },
  { name: 'nome_marca',      label: 'Nome da Marca',       placeholder: 'Nome da marca registrada', col: 1 },
  { name: 'situacao',        label: 'Situação',            placeholder: 'Ex: Registro de marca em vigor', col: 2 },
  { name: 'titular',         label: 'Titular',             placeholder: 'Nome do titular', col: 1 },
  { name: 'procurador',      label: 'Procurador',          placeholder: 'Nome do procurador', col: 1 },
  { name: 'apresentacao',    label: 'Apresentação',        placeholder: 'Ex: Mista', col: 1 },
  { name: 'natureza',        label: 'Natureza',            placeholder: 'Ex: Produtos e/ou Serviço', col: 1 },
  { name: 'classes',         label: 'Classe de Nice',      placeholder: 'Ex: NCL(12) 45', col: 1 },
  { name: 'deposito',        label: 'Data de Depósito',    placeholder: 'dd/mm/aaaa', col: 1 },
  { name: 'concessao',       label: 'Data de Concessão',   placeholder: 'dd/mm/aaaa', col: 1 },
  { name: 'vencimento',      label: 'Data de Vigência',    placeholder: 'dd/mm/aaaa', col: 1 },
];

const FORM_VAZIO = {
  // Identificação
  nome: '', razao_social: '', cpf: '', rg: '', orgao: '', cnpj: '',
  data_nascimento: '', data_contrato: '',
  inscricao_municipal: '', inscricao_estadual: '',
  // Contato
  telefone: '', email: '', email_financeiro: '',
  responsavel: '', po: '',
  // Endereço
  cep: '', rua: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '',
  referencia: '',
  // Comercial
  shopping: '', contador: '',
  programa: '', atividade: '', tipo_pagamento: '',
  consultor: '',
  indicacao: '', avaliacao: '',
  financeiro: '', regime_tributario: '',
  horario_seg_sex: '', horario_sabado: '', horario_domingo: '',
  nao_recuperado: false,
  // Outras
  outras_info: '', observacao: '',
};

const TAREFA_NOVA = { descricao: '', data_agendada: '', destinado_a: '', realizado: '', subagenda: 'cliente' };
const SUBAGENDAS_OP = [['', '📥 Geral'], ['administrativo', '🗂️ Administrativo'], ['comercial', '💼 Comercial'], ['cliente', '👥 Cliente'], ['demandas', '⚖️ Demandas Processuais'], ['pessoal', '🏠 Pessoal']];

function parseDataHora(val) {
  if (!val) return { data: '', hora: '' };
  const [data, hora] = val.includes('T') ? val.split('T') : [val, ''];
  return { data, hora: hora ? hora.slice(0, 5) : '' };
}
function combinarDataHora(data, hora) {
  if (!data) return '';
  return hora ? `${data}T${hora}` : data;
}
function fmtDt(iso) {
  if (!iso) return '—';
  if (iso.includes('T')) {
    const [datePart, timePart] = iso.split('T');
    const [ano, mes, dia] = datePart.split('-');
    return `${dia}/${mes}/${ano.slice(2)} ${timePart.slice(0, 5)}`;
  }
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano.slice(2)}`;
}
function DataHoraInput({ value, onChange, inpStyle }) {
  const { data, hora } = parseDataHora(value);
  function handleHora(e) {
    let v = e.target.value.replace(/[^0-9:]/g, '');
    if (/^\d{4}$/.test(v)) v = v.slice(0, 2) + ':' + v.slice(2);
    onChange(combinarDataHora(data, v));
  }
  return (
    <div style={{ display: 'flex', gap: 6 }}>
      <input type="date" value={data}
        onChange={e => onChange(combinarDataHora(e.target.value, hora))}
        style={{ ...inpStyle, flex: 1 }} />
      <input type="text" value={hora} placeholder="HH:MM" maxLength={5}
        onChange={handleHora}
        style={{ ...inpStyle, width: 70, flex: 'none' }} />
    </div>
  );
}

const ESTADOS_BR = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

function token() { return localStorage.getItem('token'); }
const fmtPrazo = (iso) => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(2, 4)}` : '—';
function isAdmin() { return localStorage.getItem('nomeUsuario') === 'Vagner Freitas'; }
// Estilo base dos inputs
const inp = {
  width: '100%', padding: '3px 6px', borderRadius: 3,
  border: '1px solid #b0b8c4', fontSize: 13, color: '#111',
  boxSizing: 'border-box', background: '#fff', height: 26,
};

const lbl = {
  fontSize: 12, fontWeight: 600, color: '#374151',
  whiteSpace: 'nowrap', paddingRight: 6, minWidth: 0,
};

// Linha de campos: label + input lado a lado
function Row({ fields }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 0, borderBottom: '1px solid #e8eaed', padding: '3px 0', flexWrap: 'wrap' }}>
      {fields.map(({ label, children, flex = 1, labelFlex }, i) => (
        <React.Fragment key={i}>
          {i > 0 && <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 6px' }} />}
          {/* minWidth min-content: com flex numérico (basis 0) o campo "sempre
              cabia" e o conteúdo vazava no celular — assim ele quebra linha */}
          <div style={{ display: 'flex', alignItems: 'center', flex, minWidth: 'min-content', gap: 4 }}>
            {label && <span style={{ ...lbl, flexShrink: 0, flex: labelFlex || 'none' }}>{label}:</span>}
            <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default function FormCliente({ clienteId: clienteIdProp, dadosIniciais } = {}) {
  const { id: paramId } = useParams();
  const id = clienteIdProp ?? paramId;
  const navigate = useNavigate();
  const location = useLocation();
  const editando = Boolean(id);

  const [aba, setAba] = useState('identificacao');
  const [form, setForm] = useState(() => dadosIniciais ? { ...FORM_VAZIO, ...dadosIniciais } : FORM_VAZIO);
  const [processos, setProcessos] = useState([{ ...PROCESSO_VAZIO }]);

  // ⚖️ Demandas processuais do cliente (lançadas por processo)
  const [demandasCliente, setDemandasCliente] = useState([]);
  const [modalNovaDemanda, setModalNovaDemanda] = useState(null); // clienteInfo
  const [demandaEditar, setDemandaEditar] = useState(null);
  const [desfechoDemanda, setDesfechoDemanda] = useState(null); // {demanda, acao}
  const carregarDemandas = useCallback(() => {
    if (!id) return;
    fetch(`/demandas?cliente_id=${id}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => Array.isArray(d) && setDemandasCliente(d)).catch(() => {});
  }, [id]);
  useEffect(() => { carregarDemandas(); }, [carregarDemandas]);
  async function reabrirDemanda(dm) {
    await fetch(`/demandas/${dm._id}/reabrir`, { method: 'PUT', headers: { Authorization: `Bearer ${token()}` } }).catch(() => {});
    carregarDemandas();
  }
  async function excluirDemanda(dm) {
    if (!window.confirm(`Excluir a demanda "${dm.tipo}"?`)) return;
    const r = await fetch(`/demandas/${dm._id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } }).then(x => x.json()).catch(() => ({}));
    if (r.erro) window.alert(r.erro);
    carregarDemandas();
  }
  const [carregando, setCarregando] = useState(editando);
  const [erro, setErro] = useState('');
  const [confirmacaoProcesso, setConfirmacaoProcesso] = useState(null);
  const [consultando, setConsultando] = useState(null);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [erroCep, setErroCep] = useState('');
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [erroCnpj, setErroCnpj] = useState('');

  const [listaNavegacao, setListaNavegacao] = useState([]);
  const [tarefas, setTarefas] = useState([]);
  const [novaTarefa, setNovaTarefa] = useState({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' });
  const [adicionandoTarefa, setAdicionandoTarefa] = useState(true);
  const [salvandoTarefa, setSalvandoTarefa] = useState(false);
  const [editandoTarefa, setEditandoTarefa] = useState(null);
  const [tarefaEditForm, setTarefaEditForm] = useState({});
  const [confirmacaoTarefa, setConfirmacaoTarefa] = useState(null);

  // Carrega lista ordenada de clientes para navegação
  useEffect(() => {
    api.listarClientes()
      .then(lista => {
        const comData = lista.filter(c => c.criado_em).sort((a, b) => new Date(a.criado_em) - new Date(b.criado_em));
        const semData = lista.filter(c => !c.criado_em).sort((a, b) => {
          const na = Number((a.processos?.[0]?.numero_processo || a.numero_processo || '0').replace(/\D/g,''));
          const nb = Number((b.processos?.[0]?.numero_processo || b.numero_processo || '0').replace(/\D/g,''));
          return nb - na;
        });
        setListaNavegacao([...comData, ...semData].map(c => c._id));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!editando) return;
    api.buscarCliente(id)
      .then(c => {
        setForm({
          nome: c.nome || '', razao_social: c.razao_social || '',
          cpf: c.cpf || '', rg: c.rg || '', orgao: c.orgao || '',
          cnpj: c.cnpj || '', data_nascimento: c.data_nascimento || '',
          data_contrato: c.data_contrato || '',
          inscricao_municipal: c.inscricao_municipal || '',
          inscricao_estadual: c.inscricao_estadual || '',
          telefone: c.telefone || '', email: c.email || '',
          email_financeiro: c.email_financeiro || '',
          responsavel: c.responsavel || '', po: c.po || '',
          cep: c.cep || '', rua: c.rua || '', numero: c.numero || '',
          complemento: c.complemento || '', bairro: c.bairro || '',
          cidade: c.cidade || '', estado: c.estado || '',
          referencia: c.referencia || '',
          shopping: c.shopping || '', contador: c.contador || '',
          programa: c.programa || '', atividade: c.atividade || '',
          tipo_pagamento: c.tipo_pagamento || '',
          consultor: c.consultor || '',
          indicacao: c.indicacao || '', avaliacao: c.avaliacao || '',
          financeiro: c.financeiro || '', regime_tributario: c.regime_tributario || '',
          horario_seg_sex: c.horario_seg_sex || '',
          horario_sabado: c.horario_sabado || '',
          horario_domingo: c.horario_domingo || '',
          nao_recuperado: c.nao_recuperado || false,
          outras_info: c.outras_info || '', observacao: c.observacao || '',
        });
        const procs = c.processos?.length
          ? c.processos.map(p => ({ ...PROCESSO_VAZIO, ...p }))
          : [{ ...PROCESSO_VAZIO, nome_marca: c.nome_marca || '', numero_processo: c.numero_processo || '' }];
        setProcessos(procs);
        if (c.venda) setVenda(c.venda);
        if (c.parcelas?.length) setParcelas(c.parcelas);
      })
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, [id, editando]);

  const carregarTarefas = useCallback(() => {
    if (!id) return;
    fetch(`/agenda?cliente_id=${id}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json())
      .then(data => setTarefas([...data].sort((a, b) => new Date(b.criado_em) - new Date(a.criado_em))))
      .catch(() => {});
  }, [id]);

  useEffect(() => { carregarTarefas(); }, [carregarTarefas]);

  function f(name) { return form[name] ?? ''; }

  // Navegação entre clientes
  const idxAtual = listaNavegacao.indexOf(id);
  // Quando não há id (cadastro em branco/novo), ‹ vai para o último da lista
  const idAnterior = idxAtual > 0
    ? listaNavegacao[idxAtual - 1]
    : idxAtual === -1 && listaNavegacao.length > 0
      ? listaNavegacao[listaNavegacao.length - 1]
      : null;
  const idProximo = idxAtual >= 0 && idxAtual < listaNavegacao.length - 1 ? listaNavegacao[idxAtual + 1] : null;
  const cadastroEmBranco = !form.nome && !form.razao_social && !form.responsavel &&
    processos.every(p => !p.nome_marca && !p.numero_processo);

  function navegar(destId) { navigate(`/clientes/${destId}/editar`); }
  function set(name) { return e => setForm(prev => ({ ...prev, [name]: e.target.value })); }

  async function buscarCep(cepVal) {
    const c = (cepVal || form.cep || '').replace(/\D/g, '');
    if (c.length !== 8) { if (cepVal === undefined) setErroCep('CEP deve ter 8 dígitos.'); return; }
    setErroCep('');
    setBuscandoCep(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${c}/json/`);
      const data = await res.json();
      if (data.erro) { setErroCep('CEP não encontrado.'); }
      else {
        setForm(prev => ({
          ...prev,
          rua: data.logradouro || prev.rua,
          bairro: data.bairro || prev.bairro,
          cidade: data.localidade || prev.cidade,
          estado: data.uf || prev.estado,
        }));
      }
    } catch { setErroCep('Erro ao consultar o CEP.'); }
    finally { setBuscandoCep(false); }
  }

  async function buscarCnpj() {
    const cnpj = form.cnpj.replace(/\D/g, '');
    if (cnpj.length !== 14) { setErroCnpj('CNPJ deve ter 14 dígitos.'); return; }
    setErroCnpj('');
    setBuscandoCnpj(true);
    try {
      const res = await fetch(`/clientes/consultar-cnpj/${cnpj}`, { headers: { Authorization: `Bearer ${token()}` } });
      if (!res.ok) { const e = await res.json(); setErroCnpj(e.erro || 'CNPJ não encontrado na Receita Federal.'); return; }
      const d = await res.json();
      setForm(prev => ({
        ...prev,
        razao_social: d.razao_social || prev.razao_social,
        nome:         d.nome_fantasia || prev.nome,
        email:        d.email || prev.email,
        telefone:     d.telefone ? d.telefone.replace(/\D/g,'').replace(/^(\d{2})(\d+)/, '($1) $2') : prev.telefone,
        cep:          d.cep || prev.cep,
        rua:          d.rua || prev.rua,
        numero:       d.numero || prev.numero,
        complemento:  d.complemento || prev.complemento,
        bairro:       d.bairro || prev.bairro,
        cidade:       d.cidade || prev.cidade,
        estado:       d.estado || prev.estado,
        atividade:    d.atividade || prev.atividade,
      }));
    } catch { setErroCnpj('Erro ao consultar a Receita Federal.'); }
    finally { setBuscandoCnpj(false); }
  }

  function atualizarProcesso(index, field, value) {
    setProcessos(p => p.map((item, i) => i === index ? { ...item, [field]: value } : item));
  }

  function adicionarProcesso() {
    setProcessos(p => [...p, { ...PROCESSO_VAZIO }]);
  }

  function confirmarRemocaoProcesso() {
    setProcessos(p => p.filter((_, i) => i !== confirmacaoProcesso));
    setConfirmacaoProcesso(null);
  }

  // 🏛️ Baixa a página oficial do processo no site do INPI em PDF (~20-30s)
  const [baixandoPagInpi, setBaixandoPagInpi] = useState(null);
  async function baixarPaginaInpi(index) {
    const numero = (processos[index].numero_processo || '').replace(/\D/g, '');
    if (!numero) return alert('Preencha o número do processo antes de baixar a página.');
    if (baixandoPagInpi !== null) return;
    setBaixandoPagInpi(index);
    try {
      const r = await fetch(`/inpi/pagina-pdf/${encodeURIComponent(numero)}`, { headers: { Authorization: `Bearer ${token()}` } });
      if (!r.ok) {
        let det = ''; try { det = (await r.json()).erro || ''; } catch { /* não-JSON */ }
        return alert(`Não consegui baixar a página do INPI (HTTP ${r.status}). ${det}`.trim());
      }
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement('a');
      const nomeLimpo = String(processos[index].nome_marca || '').trim().replace(/[\\/:*?"<>|]/g, '');
      a.href = url; a.download = nomeLimpo ? `${nomeLimpo}.pdf` : `INPI ${numero}.pdf`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      alert('Falha ao baixar a página do INPI: ' + (e?.message || 'erro de rede'));
    } finally {
      setBaixandoPagInpi(null);
    }
  }

  async function consultarINPI(index) {
    const numero = processos[index].numero_processo?.trim();
    if (!numero) return alert('Preencha o número do processo antes de consultar.');
    setConsultando(index);
    try {
      const res = await fetch(`/inpi/consultar/${encodeURIComponent(numero)}`, { headers: { Authorization: `Bearer ${token()}` } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.erro || 'Erro ao consultar');
      if (!data.encontrado) return alert(data.mensagem || 'Processo não encontrado.');
      const p = data.processo;
      setProcessos(prev => prev.map((item, i) => i === index ? {
        ...item,
        nome_marca: p.marca || item.nome_marca, situacao: p.situacao || item.situacao,
        apresentacao: p.apresentacao || item.apresentacao, natureza: p.natureza || item.natureza,
        classes: p.classes || item.classes, deposito: p.deposito || item.deposito,
        concessao: p.concessao || item.concessao, vencimento: p.vencimento || item.vencimento,
        titular: p.titular || item.titular, procurador: p.procurador || item.procurador,
      } : item));
    } catch (e) {
      const msg = e.message?.includes('timeout') || e.message?.includes('INPI_INACESSIVEL')
        ? 'O INPI está inacessível no momento.\n\nConsulte manualmente em:\nhttps://busca.inpi.gov.br'
        : 'Erro ao consultar INPI: ' + e.message;
      alert(msg);
    } finally {
      setConsultando(null);
    }
  }

  // 🔔 Lembrete no WhatsApp 30min antes: usa o mesmo motor da Agenda
  // (campo lembrete_em + robô que varre a cada 5 min e dispara pro
  // telefone de quem marcou). Precisa de HORA na tarefa pra ter de onde
  // descontar os 30 minutos.
  const MIN_ANTES = 30;
  async function aplicarLembrete(tid, dataAgendada, querLembrete) {
    if (!tid) return '';
    if (!querLembrete) {
      await fetch(`/agenda/${tid}/lembrete`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } }).catch(() => {});
      return '';
    }
    if (!String(dataAgendada || '').includes('T')) {
      return '⚠️ A tarefa foi salva, mas o lembrete precisa de HORA — preencha o campo HH:MM e marque de novo.';
    }
    const quando = new Date(new Date(dataAgendada).getTime() - MIN_ANTES * 60000);
    const p = (n) => String(n).padStart(2, '0');
    const iso = `${quando.getFullYear()}-${p(quando.getMonth() + 1)}-${p(quando.getDate())}T${p(quando.getHours())}:${p(quando.getMinutes())}`;
    const r = await fetch(`/agenda/${tid}/lembrete`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ lembrete_em: iso }),
    }).catch(() => null);
    if (!r || !r.ok) return '⚠️ Tarefa salva, mas não consegui marcar o lembrete — tente pelo botão 🔔 da Agenda.';
    return `🔔 Lembrete marcado: você recebe no WhatsApp às ${p(quando.getHours())}:${p(quando.getMinutes())} (30 min antes).`;
  }

  async function salvarTarefa() {
    if (!novaTarefa.descricao.trim()) return alert('Preencha a descrição da tarefa.');
    setSalvandoTarefa(true);
    const nomeCliente = form.nome || processos[0]?.nome_marca || '';
    const r = await fetch('/agenda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ ...novaTarefa, cliente_id: id, cliente_nome: nomeCliente }),
    });
    const criada = await r.json().catch(() => null);
    const aviso = await aplicarLembrete(criada?._id, novaTarefa.data_agendada, novaTarefa.lembrar30);
    setSalvandoTarefa(false);
    if (aviso) alert(aviso);
    setNovaTarefa({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' });
    setAdicionandoTarefa(false);
    carregarTarefas();
  }

  async function salvarEdicaoTarefa(tid) {
    await fetch(`/agenda/${tid}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify(tarefaEditForm),
    });
    const aviso = await aplicarLembrete(tid, tarefaEditForm.data_agendada, tarefaEditForm.lembrar30);
    if (aviso) alert(aviso);
    setEditandoTarefa(null);
    carregarTarefas();
  }

  async function excluirTarefa() {
    await fetch(`/agenda/${confirmacaoTarefa}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmacaoTarefa(null);
    carregarTarefas();
  }

  // ── Estado da aba Venda ──────────────────────────────────────────────────
  const VENDA_VAZIA = {
    servico: '', valor: '', forma_pagamento: '', num_parcelas: 1, data_primeira_parcela: '',
  };
  const [venda, setVenda] = useState(VENDA_VAZIA);
  const [parcelas, setParcelas] = useState([]);


  const FORMAS_PARCELADAS = ['Cartão de Crédito', 'Boleto Parcelado', 'Pix Parcelado'];
  const isParcelado = FORMAS_PARCELADAS.includes(venda.forma_pagamento);

  useEffect(() => {
    if (!isParcelado || !venda.valor || !venda.num_parcelas || !venda.data_primeira_parcela) {
      setParcelas([]);
      return;
    }
    const total = parseFloat(venda.valor.replace(',', '.')) || 0;
    const n = parseInt(venda.num_parcelas) || 1;
    const valorParcela = total / n;
    const base = new Date(venda.data_primeira_parcela + 'T12:00:00');
    const novas = Array.from({ length: n }, (_, i) => {
      const dt = new Date(base);
      dt.setMonth(dt.getMonth() + i);
      return {
        numero: i + 1,
        vencimento: dt.toLocaleDateString('pt-BR'),
        valor: valorParcela.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        status: 'Pendente',
      };
    });
    setParcelas(novas);
  }, [venda.valor, venda.forma_pagamento, venda.num_parcelas, venda.data_primeira_parcela, isParcelado]);

  // ── Salvamento automático ────────────────────────────────────────────────
  // Salva 1s após a última alteração em qualquer campo, em qualquer aba.
  // Cliente novo: o primeiro salvamento cria o registro e entra em modo edição.
  const [autoStatus, setAutoStatus] = useState(''); // '' | 'salvando' | 'salvo' | 'erro'
  const [msgCliente, setMsgCliente] = useState(false); // 💬 agendar mensagem pro cliente
  // 📋 Especificações de Nice do processo (modal com copiar tudo)
  const [especif, setEspecif] = useState(null);
  const [especifCopiado, setEspecifCopiado] = useState(false);

  async function abrirEspecificacoes(p) {
    const num = String(p.numero_processo || '').replace(/\D/g, '');
    if (num.length < 6) return alert('Este processo não tem número válido.');
    try {
      const r = await fetch(`/marcas-rpi/especificacoes/${num}`, { headers: { Authorization: `Bearer ${token()}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Falha na consulta');
      setEspecifCopiado(false);
      setEspecif({ ...d, marca: p.nome_marca || d.nome_marca });
    } catch (e) { alert('Não consegui buscar as especificações: ' + e.message); }
  }

  function copiarEspecificacoes() {
    if (!especif) return;
    const texto = (especif.classes || [])
      .map(c => `Classe ${c.codigo}${c.status ? ` (${c.status})` : ''}\n${c.especificacao || '(sem especificação)'}`)
      .join('\n\n');
    navigator.clipboard.writeText(`${especif.marca} — processo ${especif.numero}\n\n${texto}`)
      .then(() => { setEspecifCopiado(true); setTimeout(() => setEspecifCopiado(false), 2500); })
      .catch(() => alert('Não consegui copiar — selecione e copie manualmente.'));
  }
  const ultimoSalvoRef = useRef(null);
  const criandoRef = useRef(false);

  useEffect(() => {
    if (carregando) return;
    const dados = {
      ...form, processos,
      nome_marca: processos[0]?.nome_marca || '',
      numero_processo: processos[0]?.numero_processo || '',
      venda, parcelas,
    };
    const snapshot = JSON.stringify(dados);
    // Primeira execução após carregar: só registra o estado, não salva.
    if (ultimoSalvoRef.current === null) { ultimoSalvoRef.current = snapshot; return; }
    if (snapshot === ultimoSalvoRef.current) return;

    const timer = setTimeout(async () => {
      // Cliente novo só é criado quando há pelo menos um nome.
      if (!editando && !form.nome.trim() && !form.razao_social.trim()) return;
      if (!editando && criandoRef.current) return;
      setAutoStatus('salvando');
      setErro('');
      try {
        if (editando) {
          await api.atualizarCliente(id, dados);
        } else {
          criandoRef.current = true;
          const novo = await api.criarCliente(dados);
          ultimoSalvoRef.current = snapshot;
          setAutoStatus('salvo');
          navigate(`/clientes/${novo._id}/editar`, { replace: true });
          return;
        }
        ultimoSalvoRef.current = snapshot;
        setAutoStatus('salvo');
        setTimeout(() => setAutoStatus(s => (s === 'salvo' ? '' : s)), 2500);
      } catch (e) {
        setAutoStatus('erro');
        setErro('Falha ao salvar automaticamente: ' + e.message);
        if (!editando) criandoRef.current = false;
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [form, processos, venda, parcelas, carregando, editando, id, navigate]);

  if (carregando) return (
    <div style={{ maxWidth: 960 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 10, gap: 6 }}>
        <button type="button" disabled style={{ background: '#e5e7eb', color: '#9ca3af', border: '1px solid #d1d5db', borderRadius: 6, width: 36, height: 36, fontSize: 22, cursor: 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>‹</button>
        <button type="button" disabled style={{ background: '#e5e7eb', color: '#9ca3af', border: '1px solid #d1d5db', borderRadius: 6, width: 36, height: 36, fontSize: 22, cursor: 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>›</button>
      </div>
      <div style={{ textAlign: 'center', padding: 60, color: '#6b7280' }}>Carregando...</div>
    </div>
  );

  const ABAS = [
    { key: 'identificacao', label: 'Identificação' },
    { key: 'processos',     label: 'Processos' },
    { key: 'venda',         label: 'Venda' },
    { key: 'documentos',    label: 'Documentos' },
    { key: 'tarefas',       label: 'Tarefas' },
    { key: 'mensagens',     label: '💬 Mensagens' },
    { key: 'upload',        label: 'Upload' },
  ];

  return (
    <div style={{ maxWidth: 960 }}>
      {confirmacaoProcesso !== null && (
        <ModalConfirmar mensagem="Remover este processo?" onConfirmar={confirmarRemocaoProcesso} onCancelar={() => setConfirmacaoProcesso(null)} />
      )}
      {/* 📋 Especificações de Nice */}
      {especif && (
        <div onClick={() => setEspecif(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 640, maxWidth: '95vw', maxHeight: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.35)' }}>
            <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>📋 Especificações de Nice</div>
                <div style={{ color: '#94a3b8', fontSize: 11.5 }}>{especif.marca} · processo {especif.numero}</div>
              </div>
              <button onClick={() => setEspecif(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
              {(especif.classes || []).length === 0 && <div style={{ color: '#9ca3af', fontSize: 13 }}>A biblioteca não tem as classes deste processo.</div>}
              {(especif.classes || []).map((c, k) => (
                <div key={k} style={{ marginBottom: 12, border: '1px solid #e8eaed', borderRadius: 8, overflow: 'hidden' }}>
                  <div style={{ background: '#f8fafc', padding: '6px 12px', fontSize: 12.5, fontWeight: 800, color: '#0a1628' }}>
                    Classe {c.codigo}{c.status ? <span style={{ color: '#6b7280', fontWeight: 600 }}> · {c.status}</span> : null}
                  </div>
                  <div style={{ padding: '8px 12px', fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                    {c.especificacao || '(sem especificação registrada)'}
                  </div>
                </div>
              ))}
            </div>
            <div style={{ borderTop: '1px solid #e8eaed', padding: '10px 16px', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button onClick={() => setEspecif(null)} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Fechar</button>
              <button onClick={copiarEspecificacoes}
                style={{ background: especifCopiado ? '#16a34a' : '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                {especifCopiado ? '✓ Copiado!' : '📋 Copiar tudo'}
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmacaoTarefa && (
        <ModalConfirmar mensagem="Excluir esta tarefa?" onConfirmar={excluirTarefa} onCancelar={() => setConfirmacaoTarefa(null)} />
      )}

      {/* Cabeçalho */}
      {/* ⚖️ Modais das demandas processuais */}
      {modalNovaDemanda && <ModalDemanda clienteInfo={modalNovaDemanda}
        onFechar={() => setModalNovaDemanda(null)} onSalvo={() => { setModalNovaDemanda(null); carregarDemandas(); }} />}
      {demandaEditar && <ModalDemanda demanda={demandaEditar}
        onFechar={() => setDemandaEditar(null)} onSalvo={() => { setDemandaEditar(null); carregarDemandas(); }} />}
      {desfechoDemanda && <ModalDesfechoDemanda demanda={desfechoDemanda.demanda} acao={desfechoDemanda.acao}
        onFechar={() => setDesfechoDemanda(null)} onSalvo={() => { setDesfechoDemanda(null); carregarDemandas(); }} />}

      {msgCliente && <AgendarMensagemCliente
        alvo={{ cliente_id: paramId || '', cliente_nome: f('nome') || '', telefone: f('telefone') || '' }}
        onFechar={() => setMsgCliente(false)} />}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
        <div>
          <Link to="/clientes" style={{ color: '#6b7280', fontSize: 12, textDecoration: 'none' }}>← Clientes</Link>
          <h1 style={{ fontSize: 17, fontWeight: 700, marginTop: 2, color: '#0a1628' }}>
            {/* Título vivo (pedido 17/08): primeiro nome do cliente + marca —
                navegando com os botões ‹ › dá pra achar o cliente sem abrir nada */}
            {(() => {
              if (!editando) return 'Novo Cliente';
              const primeiro = (form.nome || form.razao_social || '').trim().split(/\s+/)[0] || '';
              const marca = (processos[0]?.nome_marca || form.nome_marca || '').trim();
              const titulo = [primeiro, marca].filter(Boolean).join(' · ');
              return titulo || 'Editar Cliente';
            })()}
          </h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {editando && (
              <button type="button" onClick={() => setMsgCliente(true)}
                title="Agendar uma mensagem de WhatsApp para este cliente, na data e hora que você escolher"
                style={{ background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0', borderRadius: 4, padding: '4px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                💬 Agendar mensagem
              </button>
            )}
            {autoStatus === 'salvando' && <span style={{ fontSize: 12, color: '#b45309', fontWeight: 600 }}>Salvando...</span>}
            {autoStatus === 'salvo' && <span style={{ fontSize: 12, color: '#16a34a', fontWeight: 600 }}>✓ Salvo</span>}
            {autoStatus === 'erro' && <span style={{ fontSize: 12, color: '#dc2626', fontWeight: 600 }}>⚠ Erro ao salvar</span>}
            {listaNavegacao.length > 0 && idxAtual >= 0 && (
              <span style={{ fontSize: 11, color: '#9ca3af' }}>{idxAtual + 1} / {listaNavegacao.length}</span>
            )}
            <button
              type="button"
              onClick={() => idAnterior && navegar(idAnterior)}
              disabled={!idAnterior}
              title="Cliente anterior"
              style={{ background: idAnterior ? '#0a1628' : '#e5e7eb', color: idAnterior ? '#fff' : '#9ca3af', border: '1px solid #d1d5db', borderRadius: 6, width: 36, height: 36, fontSize: 22, cursor: idAnterior ? 'pointer' : 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, flexShrink: 0 }}>
              ‹
            </button>
            <button
              type="button"
              onClick={() => idProximo && !cadastroEmBranco && navegar(idProximo)}
              disabled={!idProximo || cadastroEmBranco}
              title={cadastroEmBranco ? 'Cadastro em branco — próximo bloqueado' : 'Próximo cliente'}
              style={{ background: (idProximo && !cadastroEmBranco) ? '#0a1628' : '#e5e7eb', color: (idProximo && !cadastroEmBranco) ? '#fff' : '#9ca3af', border: '1px solid #d1d5db', borderRadius: 6, width: 36, height: 36, fontSize: 22, cursor: (idProximo && !cadastroEmBranco) ? 'pointer' : 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, flexShrink: 0 }}>
              ›
            </button>
          </div>
      </div>

      {/* Abas */}
      <div style={{ display: 'flex', borderBottom: '2px solid #0a1628', marginBottom: 0, flexWrap: 'wrap' }}>
        {ABAS.map(a => (
          <button key={a.key} type="button" onClick={() => setAba(a.key)}
            style={{
              padding: '6px 18px', fontSize: 13, fontWeight: 600,
              color: aba === a.key ? '#fff' : '#374151',
              background: aba === a.key ? '#0a1628' : '#e5e7eb',
              border: 'none', cursor: 'pointer', borderRadius: '6px 6px 0 0',
              marginRight: 2,
            }}>
            {a.label}
          </button>
        ))}
      </div>

      <form onSubmit={e => e.preventDefault()}>

        {/* ── ABA: IDENTIFICAÇÃO ── */}
        {aba === 'identificacao' && (
          <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '10px 14px' }}>

            <SectionHeader>Identificação</SectionHeader>
            <Row fields={[
              { label: 'Fantasia', flex: 3, children: <input value={f('nome')} onChange={set('nome')} style={inp} required /> },
              { label: 'Cadastrado em', flex: 1, children: <input value={editando ? '—' : new Date().toLocaleDateString('pt-BR')} readOnly style={{ ...inp, background: '#f5f5f5', color: '#888' }} /> },
            ]} />
            <Row fields={[
              { label: 'Razão Social', flex: 1, children: <input value={f('razao_social')} onChange={set('razao_social')} style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'Endereço', flex: 3, children: <input value={f('rua')} onChange={set('rua')} placeholder="Rua, Avenida..." style={inp} /> },
              { label: 'Número', flex: 1, children: <input value={f('numero')} onChange={set('numero')} placeholder="Nº" style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'Bairro', flex: 2, children: <input value={f('bairro')} onChange={set('bairro')} style={inp} /> },
              { label: 'Cidade', flex: 2, children: <input value={f('cidade')} onChange={set('cidade')} style={inp} /> },
              { label: 'UF', flex: 0.4, children:
                <select value={f('estado')} onChange={set('estado')} style={{ ...inp, padding: '2px 2px' }}>
                  <option value=""></option>
                  {ESTADOS_BR.map(e => <option key={e} value={e}>{e}</option>)}
                </select>
              },
            ]} />
            <Row fields={[
              { label: 'CEP', flex: 1, children:
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <input value={f('cep')} onChange={e => { set('cep')(e); buscarCep(e.target.value); }} placeholder="00000-000" style={{ ...inp, flex: 1 }} />
                  <button type="button" onClick={() => buscarCep()} disabled={buscandoCep}
                    style={{ whiteSpace: 'nowrap', padding: '2px 10px', fontSize: 12, fontWeight: 600,
                      background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', height: 26 }}>
                    {buscandoCep ? 'Buscando...' : '🔍 Consultar CEP'}
                  </button>
                </div>
              },
              { label: 'Telefones', flex: 2, children: <input value={f('telefone')} onChange={set('telefone')} placeholder="(83) 99999-9999" style={inp} /> },
            ]} />
            {erroCep && <div style={{ color: '#dc2626', fontSize: 12, padding: '2px 8px' }}>{erroCep}</div>}
            <Row fields={[
              { label: 'Referência', flex: 1, children: <input value={f('referencia')} onChange={set('referencia')} placeholder="Ponto de referência..." style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'Outras Info', flex: 1, children: <input value={f('outras_info')} onChange={set('outras_info')} style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'CNPJ', flex: 1, children: (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <input value={f('cnpj')} onChange={set('cnpj')} placeholder="00.000.000/0000-00" style={{ ...inp, flex: 1 }} />
                  <button type="button" onClick={buscarCnpj} disabled={buscandoCnpj}
                    style={{ whiteSpace: 'nowrap', padding: '2px 10px', fontSize: 12, fontWeight: 600,
                      background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', height: 26 }}>
                    {buscandoCnpj ? 'Consultando...' : '🔍 Consultar CNPJ'}
                  </button>
                </div>
              )},
            ]} />
            {erroCnpj && <div style={{ color: '#dc2626', fontSize: 12, padding: '2px 8px' }}>{erroCnpj}</div>}
            <Row fields={[
              { label: 'E-mail', flex: 2, children: <input type="email" value={f('email')} onChange={set('email')} placeholder="email@exemplo.com" style={inp} /> },
              { label: 'E-mail Financeiro', flex: 2, children: <input type="email" value={f('email_financeiro')} onChange={set('email_financeiro')} style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'Responsável', flex: 2, children: <input value={f('responsavel')} onChange={set('responsavel')} style={inp} /> },
              { label: 'PO', flex: 1, children: <input value={f('po')} onChange={set('po')} style={inp} /> },
              { label: 'Data Contrato', flex: 1, children: <input type="date" value={f('data_contrato')} onChange={set('data_contrato')} style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'CPF', flex: 1, children: <input value={f('cpf')} onChange={set('cpf')} placeholder="000.000.000-00" style={inp} /> },
              { label: 'RG', flex: 1, children: <input value={f('rg')} onChange={set('rg')} style={inp} /> },
              { label: 'Órgão', flex: 1, children: <input value={f('orgao')} onChange={set('orgao')} style={inp} /> },
            ]} />
            <Row fields={[
              { label: 'Consultor', flex: 1, children: isAdmin()
                ? <SelectColaborador value={f('consultor')} onChange={v => setForm(p => ({ ...p, consultor: v }))} style={inp} />
                : <input value={f('consultor') || '—'} disabled readOnly title="Só o administrador pode trocar o consultor do cliente"
                    style={{ ...inp, background: '#f3f4f6', color: '#6b7280', cursor: 'not-allowed' }} /> },
              { label: 'Indicação', flex: 1, children: <input value={f('indicacao')} onChange={set('indicacao')} style={inp} /> },
              { label: 'Avaliação', flex: 1, children:
                <select value={f('avaliacao')} onChange={set('avaliacao')} style={{ ...inp, padding: '2px 4px' }}>
                  <option value=""></option>
                  <option>Ótimo</option><option>Bom</option><option>Regular</option><option>Ruim</option>
                </select>
              },
            ]} />
            <Row fields={[
              { label: 'Financeiro', flex: 2, children: <input value={f('financeiro')} onChange={set('financeiro')} style={inp} /> },
              { label: 'Regime Tributário', flex: 1, children:
                <select value={f('regime_tributario')} onChange={set('regime_tributario')} style={{ ...inp, padding: '2px 4px' }}>
                  <option value=""></option>
                  <option>MEI</option><option>Simples Nacional</option><option>Lucro Presumido</option><option>Lucro Real</option>
                </select>
              },
            ]} />
            <Row fields={[
              { label: 'Complemento', flex: 2, children: <input value={f('complemento')} onChange={set('complemento')} placeholder="Apto, sala, bloco..." style={inp} /> },
              { label: 'Não Recuperado', flex: 0.5, children:
                <input type="checkbox" checked={!!f('nao_recuperado')}
                  onChange={e => setForm(prev => ({ ...prev, nao_recuperado: e.target.checked }))}
                  style={{ width: 16, height: 16, cursor: 'pointer', marginTop: 4 }} />
              },
            ]} />

            <SectionHeader style={{ marginTop: 8 }}>Observações</SectionHeader>
            <div style={{ padding: '4px 0' }}>
              <textarea value={f('observacao')} onChange={set('observacao')} rows={3}
                style={{ ...inp, height: 'auto', resize: 'vertical', width: '100%', padding: '4px 6px' }}
                placeholder="Observações..." />
            </div>

            {erro && <div style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{erro}</div>}

          </div>
        )}

        {/* ── ABA: PROCESSOS ── */}
        {aba === 'processos' && (
          <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '10px 14px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
              <BtnPrimary type="button" onClick={adicionarProcesso}>+ Adicionar Processo</BtnPrimary>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {processos.map((p, i) => (
                <div key={i} style={{ border: '1px solid #c8d0da', borderRadius: 4, overflow: 'hidden' }}>
                  {/* Header processo */}
                  <div style={{ background: '#0a1628', padding: '5px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>
                      {p.nome_marca ? `™ ${p.nome_marca}` : `Processo ${i + 1}`}
                    </span>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      <button type="button"
                        onClick={() => id
                          ? setModalNovaDemanda({ cliente_id: id, cliente_nome: form.nome || form.razao_social || '', processo_numero: (p.numero_processo || '').trim(), marca: p.nome_marca || '' })
                          : window.alert('Salve o cliente antes de lançar demandas.')}
                        title="Lançar demanda processual (oposição, recurso, exigência…) com prazo"
                        style={{ background: '#7c3aed', color: '#fff', padding: '3px 10px', borderRadius: 3, fontSize: 12, border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                        ⚖️ + Demanda
                      </button>
                      <button type="button" onClick={() => baixarPaginaInpi(i)} disabled={baixandoPagInpi !== null}
                        title="Baixa a página oficial deste processo no site do INPI em PDF (demora ~30s)"
                        style={{ background: '#0891b2', color: '#fff', padding: '3px 10px', borderRadius: 3, fontSize: 12, border: 'none', cursor: baixandoPagInpi !== null ? 'wait' : 'pointer', fontWeight: 600, opacity: baixandoPagInpi !== null && baixandoPagInpi !== i ? 0.6 : 1 }}>
                        {baixandoPagInpi === i ? '⏳ Baixando…' : '🏛️ Página INPI'}
                      </button>
                      <button type="button" onClick={() => consultarINPI(i)} disabled={consultando === i}
                        style={{ background: '#fff', color: '#0a1628', padding: '3px 10px', borderRadius: 3, fontSize: 12, border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                        {consultando === i ? '⏳ ...' : '🌐 Consultar INPI'}
                      </button>
                      {processos.length > 1 && (
                        <button type="button" onClick={() => setConfirmacaoProcesso(i)}
                          style={{ background: '#dc2626', color: '#fff', padding: '3px 10px', borderRadius: 3, fontSize: 12, border: 'none', cursor: 'pointer' }}>
                          × Remover
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Campos do processo em linhas densas */}
                  <div style={{ padding: '6px 10px', display: 'flex', flexDirection: 'column' }}>
                    <PRow label="Nº Processo" value={p.numero_processo} onChange={v => atualizarProcesso(i, 'numero_processo', v)} placeholder="Ex: 935613161"
                      extra={[
                        { label: 'Nome da Marca', value: p.nome_marca, onChange: v => atualizarProcesso(i, 'nome_marca', v), placeholder: 'Nome da marca' },
                      ]} />
                    <PRow label="Situação" value={p.situacao} onChange={v => atualizarProcesso(i, 'situacao', v)} placeholder="Ex: Registro de marca em vigor" full />
                    <PRow label="Titular" value={p.titular} onChange={v => atualizarProcesso(i, 'titular', v)}
                      extra={[{ label: 'Procurador', value: p.procurador, onChange: v => atualizarProcesso(i, 'procurador', v) }]} />
                    <PRow label="Apresentação" value={p.apresentacao} onChange={v => atualizarProcesso(i, 'apresentacao', v)}
                      extra={[{ label: 'Natureza', value: p.natureza, onChange: v => atualizarProcesso(i, 'natureza', v) }]} />
                    <PRow label="Classe de Nice" value={p.classes} onChange={v => atualizarProcesso(i, 'classes', v)} placeholder="Ex: NCL(12) 45"
                      acao={{ rotulo: '📋 Especificações', title: 'Ver e copiar as especificações completas das classes (da biblioteca de RPIs)', onClick: () => abrirEspecificacoes(p) }}
                      extra={[
                        { label: 'Depósito', value: p.deposito, onChange: v => atualizarProcesso(i, 'deposito', v), placeholder: 'dd/mm/aaaa' },
                        { label: 'Concessão', value: p.concessao, onChange: v => atualizarProcesso(i, 'concessao', v), placeholder: 'dd/mm/aaaa' },
                        { label: 'Vigência', value: p.vencimento, onChange: v => atualizarProcesso(i, 'vencimento', v), placeholder: 'dd/mm/aaaa' },
                      ]} />

                    {/* ⚖️ Demandas deste processo (casadas pelo nº) */}
                    {(() => {
                      const digitos = (p.numero_processo || '').replace(/\D/g, '');
                      const doProcesso = digitos ? demandasCliente.filter(dm => (dm.processo_numero || '').replace(/\D/g, '') === digitos) : [];
                      if (!doProcesso.length) return null;
                      return (
                        <div style={{ marginTop: 6, borderTop: '1px dashed #e5e7eb', paddingTop: 6 }}>
                          {doProcesso.map(dm => {
                            const u = urgencia(dm);
                            return (
                              <div key={dm._id} style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', padding: '3px 0', fontSize: 12 }}>
                                <span style={{ background: u.bg, color: u.cor, padding: '1px 7px', borderRadius: 3, fontSize: 10.5, fontWeight: 700, whiteSpace: 'nowrap' }}>{u.rotulo}</span>
                                <span style={{ fontWeight: 700, color: '#0a1628' }}>⚖️ {dm.tipo}</span>
                                <span style={{ color: '#6b7280' }}>prazo {fmtPrazo(dm.prazo)}</span>
                                {dm.observacao && <span style={{ color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 260 }}>· {dm.observacao}</span>}
                                <span style={{ display: 'flex', gap: 4, marginLeft: 'auto' }}>
                                  {dm.status === 'pendente' ? (
                                    <>
                                      <button type="button" onClick={() => setDesfechoDemanda({ demanda: dm, acao: 'cumprir' })}
                                        style={{ background: '#16a34a', color: '#fff', padding: '1px 8px', borderRadius: 3, fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer' }}>✓</button>
                                      <button type="button" onClick={() => setDesfechoDemanda({ demanda: dm, acao: 'nao' })} title="Não cumprida"
                                        style={{ background: '#fff', color: '#dc2626', padding: '1px 7px', borderRadius: 3, fontSize: 11, fontWeight: 700, border: '1px solid #fecaca', cursor: 'pointer' }}>✗</button>
                                      <button type="button" onClick={() => setDemandaEditar(dm)} title="Editar"
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, padding: 0 }}>✏️</button>
                                    </>
                                  ) : (
                                    <button type="button" onClick={() => reabrirDemanda(dm)} title="Reabrir"
                                      style={{ background: '#f3f4f6', color: '#374151', padding: '1px 8px', borderRadius: 3, fontSize: 11, border: '1px solid #d1d5db', cursor: 'pointer' }}>↩</button>
                                  )}
                                  {localStorage.getItem('nomeUsuario') === 'Vagner Freitas' && (
                                    <button type="button" onClick={() => excluirDemanda(dm)} title="Excluir"
                                      style={{ background: 'none', color: '#dc2626', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700, padding: 0, lineHeight: 1 }}>✕</button>
                                  )}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              ))}
            </div>

            {erro && <div style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{erro}</div>}

          </div>
        )}

        {/* ── ABA: VENDA ── */}
        {aba === 'venda' && (
          <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '10px 14px' }}>
            {!(isAdmin() || (form.consultor && (form.consultor || '').trim() === (localStorage.getItem('nomeUsuario') || '').trim())) ? (
              <div style={{ color: '#6b7280', fontSize: 13, padding: 8 }}>Acesso restrito: esta aba é liberada pro administrador e pro consultor dono do cliente.</div>
            ) : !editando ? (
              <div style={{ color: '#6b7280', fontSize: 13, padding: 8 }}>Salve o cliente primeiro para lançar contas a receber.</div>
            ) : (
              <PainelLancamentos tipo="receber" idField="cliente_id" idValue={id} nomeValue={form.nome || form.razao_social || form.responsavel || ''} />
            )}
          </div>
        )}

        {/* ── ABA: DOCUMENTOS ── */}
        {aba === 'documentos' && (
          <AbaDocumentos form={form} processos={processos} clienteId={id} />
        )}

        {/* ── ABA: 💬 MENSAGENS — histórico de WhatsApp do cliente ── */}
        {aba === 'mensagens' && (
          <div style={{ padding: '4px 2px' }}>
            <HistoricoMensagens key={String(msgCliente)} clienteId={paramId || ''}
              aoAgendar={editando ? () => setMsgCliente(true) : null} />
          </div>
        )}

        {/* ── ABA: UPLOAD ── */}
        {aba === 'upload' && (
          !(isAdmin() || (form.consultor && (form.consultor || '').trim() === (localStorage.getItem('nomeUsuario') || '').trim())) ? (
            <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '14px 16px' }}>
              <div style={{ color: '#6b7280', fontSize: 13, padding: 8 }}>
                🔒 Acesso restrito: os arquivos deste cliente são liberados só pro administrador e pro consultor responsável ({form.consultor || 'sem consultor definido'}).
              </div>
            </div>
          ) : (
            <AbaUpload clienteId={id} />
          )
        )}

        {/* ── ABA: TAREFAS ── */}
        {aba === 'tarefas' && (
          <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '10px 14px' }}>
            <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
              {!adicionandoTarefa && (
                <BtnPrimary type="button" onClick={() => setAdicionandoTarefa(true)}>+ Nova Tarefa</BtnPrimary>
              )}
            </div>

            {adicionandoTarefa && (
              <div style={{ border: '2px solid #0a1628', borderRadius: 6, padding: 14, marginBottom: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', marginBottom: 8 }}>Nova Tarefa</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Descrição *</div>
                    <textarea value={novaTarefa.descricao} onChange={e => setNovaTarefa(f => ({ ...f, descricao: e.target.value }))}
                      rows={3} placeholder="Descreva o que precisa ser feito..."
                      style={{ ...inp, height: 'auto', width: '100%', resize: 'vertical', padding: '4px 6px' }} />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Data <span style={{ fontWeight: 400, color: '#9ca3af' }}>(hora opcional)</span></div>
                      <DataHoraInput value={novaTarefa.data_agendada} onChange={v => setNovaTarefa(f => ({ ...f, data_agendada: v }))} inpStyle={inp} />
                    </div>
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Destinado a</div>
                      <SelectColaborador value={novaTarefa.destinado_a} onChange={v => setNovaTarefa(f => ({ ...f, destinado_a: v }))} placeholder="Selecione..." style={{ marginTop: 0 }} />
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Subagenda</div>
                    <select value={novaTarefa.subagenda || 'cliente'} onChange={e => setNovaTarefa(f => ({ ...f, subagenda: e.target.value }))} style={{ ...inp, width: '100%' }}>
                      {SUBAGENDAS_OP.map(([v, l]) => <option key={v || 'g'} value={v}>{l}</option>)}
                    </select>
                  </div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3 }}>O que foi feito</div>
                    <textarea value={novaTarefa.realizado} onChange={e => setNovaTarefa(f => ({ ...f, realizado: e.target.value }))}
                      rows={2} placeholder="Preencherá após realização..."
                      style={{ ...inp, height: 'auto', width: '100%', resize: 'vertical', padding: '4px 6px' }} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center' }}>
                  <BtnPrimary type="button" onClick={salvarTarefa} disabled={salvandoTarefa}>{salvandoTarefa ? 'Salvando...' : 'Salvar Tarefa'}</BtnPrimary>
                  <BtnCancel type="button" onClick={() => { setAdicionandoTarefa(false); setNovaTarefa({ ...TAREFA_NOVA, destinado_a: localStorage.getItem('nomeUsuario') || '' }); }}>Cancelar</BtnCancel>
                  <button type="button" onClick={() => setNovaTarefa(f => ({ ...f, favorita: !f.favorita }))} title="Favorita: aparece no filtro ⭐ da Agenda em qualquer dia" style={{ marginLeft: 'auto', background: novaTarefa.favorita ? '#fffbeb' : '#fff', color: novaTarefa.favorita ? '#b45309' : '#6b7280', border: `1px solid ${novaTarefa.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{novaTarefa.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}</button>
                  <button type="button" onClick={() => setNovaTarefa(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: novaTarefa.urgente ? '#fee2e2' : '#fff', color: novaTarefa.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${novaTarefa.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{novaTarefa.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
                  <button type="button" onClick={() => setNovaTarefa(f => ({ ...f, lembrar30: !f.lembrar30 }))} title="Você recebe um aviso no WhatsApp 30 minutos antes da hora da tarefa (precisa preencher a hora)" style={{ background: novaTarefa.lembrar30 ? '#eff6ff' : '#fff', color: novaTarefa.lembrar30 ? '#1d4ed8' : '#6b7280', border: `1px solid ${novaTarefa.lembrar30 ? '#bfdbfe' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{novaTarefa.lembrar30 ? '🔔 Aviso 30min antes' : '🔕 Avisar 30min antes'}</button>
                </div>
              </div>
            )}

            {tarefas.length === 0 && !adicionandoTarefa && (
              <div style={{ textAlign: 'center', padding: 24, color: '#9ca3af', fontSize: 13 }}>Nenhuma tarefa cadastrada.</div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {tarefas.map(t => (
                <div key={t._id} style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 14 }}>
                  {editandoTarefa === t._id && (isAdmin() || !t.realizado) ? (
                    <div style={{ display: 'grid', gap: 8 }}>
                      <textarea value={tarefaEditForm.descricao || ''} onChange={e => setTarefaEditForm(f => ({ ...f, descricao: e.target.value }))} rows={2}
                        style={{ ...inp, height: 'auto', width: '100%', resize: 'vertical', padding: '4px 6px' }} />
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                        <DataHoraInput value={tarefaEditForm.data_agendada || ''} onChange={v => setTarefaEditForm(f => ({ ...f, data_agendada: v }))} inpStyle={inp} />
                        <SelectColaborador value={tarefaEditForm.destinado_a || ''} onChange={v => setTarefaEditForm(f => ({ ...f, destinado_a: v }))} style={{ marginTop: 0 }} />
                      </div>
                      <textarea value={tarefaEditForm.realizado || ''} onChange={e => setTarefaEditForm(f => ({ ...f, realizado: e.target.value }))} rows={2}
                        style={{ ...inp, height: 'auto', width: '100%', resize: 'vertical', padding: '4px 6px' }} />
                      <div style={{ display: 'flex', gap: 6 }}>
                        <BtnPrimary type="button" onClick={() => salvarEdicaoTarefa(t._id)}>Salvar</BtnPrimary>
                        <BtnCancel type="button" onClick={() => setEditandoTarefa(null)}>Cancelar</BtnCancel>
                        <button type="button" onClick={() => setTarefaEditForm(f => ({ ...f, favorita: !f.favorita }))} title="Favorita: aparece no filtro ⭐ da Agenda em qualquer dia" style={{ marginLeft: 'auto', background: tarefaEditForm.favorita ? '#fffbeb' : '#fff', color: tarefaEditForm.favorita ? '#b45309' : '#6b7280', border: `1px solid ${tarefaEditForm.favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{tarefaEditForm.favorita ? '⭐ Favorita' : '☆ Marcar favorita'}</button>
                        <button type="button" onClick={() => setTarefaEditForm(f => ({ ...f, urgente: !f.urgente }))} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: tarefaEditForm.urgente ? '#fee2e2' : '#fff', color: tarefaEditForm.urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${tarefaEditForm.urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{tarefaEditForm.urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
                        <button type="button" onClick={() => setTarefaEditForm(f => ({ ...f, lembrar30: !f.lembrar30 }))} title="Aviso no seu WhatsApp 30 minutos antes da hora da tarefa (precisa ter hora)" style={{ background: tarefaEditForm.lembrar30 ? '#eff6ff' : '#fff', color: tarefaEditForm.lembrar30 ? '#1d4ed8' : '#6b7280', border: `1px solid ${tarefaEditForm.lembrar30 ? '#bfdbfe' : '#d1d5db'}`, borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{tarefaEditForm.lembrar30 ? '🔔 Aviso 30min antes' : '🔕 Avisar 30min antes'}</button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span style={{ fontSize: 11, color: '#9ca3af' }}>Criado em: {fmtDt(t.criado_em)}</span>
                        <div style={{ display: 'flex', gap: 6 }}>
                          {t.realizado && !isAdmin() ? (
                            <span style={{ fontSize: 11, color: '#dc2626', background: '#fef2f2', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>🔒 Concluída</span>
                          ) : (
                            <>
                              <button type="button" onClick={() => { setEditandoTarefa(t._id); setTarefaEditForm({ descricao: t.descricao, data_agendada: t.data_agendada, destinado_a: t.destinado_a, realizado: t.realizado, favorita: !!t.favorita, urgente: !!t.urgente, lembrar30: !!(t.lembrete_em && !t.lembrete_enviado) }); }}
                                style={{ background: '#f3f4f6', color: '#374151', padding: '3px 10px', borderRadius: 4, fontSize: 12, border: 'none', cursor: 'pointer' }}>✏️ Editar</button>
                              <button type="button" onClick={() => setConfirmacaoTarefa(t._id)}
                                style={{ background: '#fef2f2', color: '#dc2626', padding: '3px 10px', borderRadius: 4, fontSize: 12, border: 'none', cursor: 'pointer' }}>🗑 Excluir</button>
                            </>
                          )}
                        </div>
                      </div>
                      <div style={{ background: '#f9fafb', borderRadius: 6, padding: '8px 10px', marginBottom: 8, fontSize: 13, color: '#111' }}>
                        <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 2 }}>TAREFA</div>
                        {t.descricao}
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                        <div style={{ background: '#eff6ff', borderRadius: 6, padding: '6px 10px' }}>
                          <div style={{ fontSize: 10, color: '#3b82f6', fontWeight: 600, marginBottom: 2 }}>DATA/HORA</div>
                          <div style={{ fontSize: 12, color: '#1e40af' }}>{fmtDt(t.data_agendada)}</div>
                          {t.lembrete_em && (
                            <div style={{ fontSize: 10.5, color: t.lembrete_enviado ? '#16a34a' : '#1d4ed8', marginTop: 2 }}
                              title={t.lembrete_enviado ? 'aviso já enviado no WhatsApp' : 'você recebe um aviso no WhatsApp nessa hora'}>
                              {t.lembrete_enviado ? '🔔 avisado' : `🔔 aviso ${fmtDt(t.lembrete_em)}`}
                            </div>
                          )}
                        </div>
                        <div style={{ background: '#f0fdf4', borderRadius: 6, padding: '6px 10px' }}>
                          <div style={{ fontSize: 10, color: '#16a34a', fontWeight: 600, marginBottom: 2 }}>DESTINADO A</div>
                          <div style={{ fontSize: 12, color: '#15803d' }}>{t.destinado_a || '—'}</div>
                        </div>
                      </div>
                      <div style={{ background: t.realizado ? '#f0fdf4' : '#fafafa', borderRadius: 6, padding: '6px 10px', border: `1px solid ${t.realizado ? '#bbf7d0' : '#e5e7eb'}` }}>
                        <div style={{ fontSize: 10, color: t.realizado ? '#16a34a' : '#9ca3af', fontWeight: 600, marginBottom: 2 }}>O QUE FOI FEITO</div>
                        <div style={{ fontSize: 12, color: t.realizado ? '#15803d' : '#9ca3af' }}>{t.realizado || 'Ainda não preenchido'}</div>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
            </>
          </div>
        )}

      </form>
    </div>
  );
}

// ── Aba Documentos ──────────────────────────────────────────────────────────
const MODELOS_DOC = [
  { key: 'procuracao_cpf',  label: 'Procuração CPF',                icone: '📄' },
  { key: 'procuracao_cnpj', label: 'Procuração CNPJ',               icone: '📄' },
  { key: 'contrato',        label: 'Contrato de Prestação de Serviço', icone: '📋' },
];

const CAMPOS_DOC = {
  procuracao_cpf: [
    { name: 'nome',          label: 'Nome completo',     placeholder: 'Ex: JOÃO DA SILVA', required: true },
    { name: 'cpf',           label: 'CPF',               placeholder: 'Ex: 000.000.000-00', required: true },
    { name: 'profissao',     label: 'Profissão',         placeholder: 'Ex: empresário(a)', required: false },
    { name: 'nacionalidade', label: 'Nacionalidade',     placeholder: 'Ex: brasileiro(a)', required: false },
    { name: 'endereco',      label: 'Endereço completo', placeholder: 'Rua, nº, bairro, cidade - UF', required: true, full: true },
  ],
  procuracao_cnpj: [
    { name: 'nome_empresa',             label: 'Razão Social',               placeholder: 'Ex: EMPRESA LTDA', required: true },
    { name: 'cnpj_empresa',             label: 'CNPJ da Empresa',            placeholder: 'Ex: 00.000.000/0001-00', required: true },
    { name: 'endereco_empresa',         label: 'Endereço da Empresa',        placeholder: 'Rua, nº, bairro, cidade - UF, CEP', required: true, full: true },
    { name: 'nome_representante',       label: 'Nome do Representante',      placeholder: 'Ex: JOÃO DA SILVA', required: true },
    { name: 'cpf_representante',        label: 'CPF do Representante',       placeholder: 'Ex: 000.000.000-00', required: true },
    { name: 'nacionalidade',            label: 'Nacionalidade',              placeholder: 'Ex: brasileiro(a)', required: false },
    { name: 'profissao_representante',  label: 'Profissão do Representante', placeholder: 'Ex: empresário(a)', required: false },
  ],
  contrato: [
    { name: 'tipo',                    label: 'Tipo de pessoa', tipo: 'select', opcoes: [{ v: 'cnpj', l: 'Pessoa Jurídica (CNPJ)' }, { v: 'cpf', l: 'Pessoa Física (CPF)' }], required: true },
    { name: 'nome_contratante',        label: 'Nome / Razão Social',        placeholder: 'Ex: EMPRESA LTDA', required: true },
    { name: 'cpf_cnpj',               label: 'CPF / CNPJ',                 placeholder: 'Ex: 00.000.000/0001-00', required: true },
    { name: 'endereco_contratante',    label: 'Endereço',                   placeholder: 'Rua, nº, bairro, cidade - UF', required: true, full: true },
    { name: 'nome_representante',      label: 'Nome do Representante',      placeholder: 'Ex: MARIA SILVA', required: true },
    { name: 'cpf_representante',       label: 'CPF do Representante',       placeholder: 'Ex: 000.000.000-00', required: true },
    { name: 'nacionalidade',           label: 'Nacionalidade',              placeholder: 'Ex: brasileiro(a)', required: false },
    { name: 'profissao_representante', label: 'Profissão do Representante', placeholder: 'Ex: empresário(a)', required: false },
    { name: 'objeto',                  label: 'Objeto do contrato',         placeholder: 'Ex: DOIS PEDIDOS DE REGISTRO DA MARCA', required: true, full: true },
    { name: 'valor',                   label: 'Valor (R$)',                 placeholder: 'Ex: R$3.200,00', required: true },
    { name: 'valor_extenso',           label: 'Valor por extenso',          placeholder: 'Ex: três mil e duzentos reais', required: true },
    // Mesma opção do Gerador de Arquivos — sem ela o contrato da ficha saía
    // SEMPRE assinado, sem escolha (reclamação do Vagner 12/08)
    { name: 'assinatura',              label: 'Assinatura do Vagner',       tipo: 'select', opcoes: [{ v: 'com', l: '✍️ Com assinatura (sai já assinado)' }, { v: 'sem', l: 'Sem assinatura (imprimir e assinar à mão)' }], required: true, full: true },
  ],
};

function montarEnderecoCliente(form) {
  return [form.rua, form.numero, form.bairro, form.cidade, form.estado].filter(Boolean).join(', ');
}

function preencherComCliente(key, form) {
  const end = montarEnderecoCliente(form);
  if (key === 'procuracao_cpf') return { nome: (form.responsavel || form.nome || '').toUpperCase(), cpf: form.cpf || '', endereco: end };
  if (key === 'procuracao_cnpj') return {
    nome_empresa: (form.razao_social || form.nome || '').toUpperCase(),
    cnpj_empresa: form.cnpj || '',
    endereco_empresa: end,
    nome_representante: (form.responsavel || form.nome || '').toUpperCase(),
    cpf_representante: form.cpf || '',
  };
  if (key === 'contrato') return {
    tipo: form.cnpj ? 'cnpj' : 'cpf',
    nome_contratante: (form.razao_social || form.nome || '').toUpperCase(),
    cpf_cnpj: form.cnpj || form.cpf || '',
    endereco_contratante: end,
    nome_representante: (form.responsavel || form.nome || '').toUpperCase(),
    cpf_representante: form.cpf || '',
    data: new Date().toISOString().split('T')[0],
  };
  return {};
}

function AbaDocumentos({ form, processos, clienteId }) {
  const [modelo, setModelo] = useState(null);
  const [campos, setCampos] = useState({});
  const [gerando, setGerando] = useState(null);
  const [pronto, setPronto] = useState(false);
  // 🖊️ D4Sign: só habilita o botão quando o servidor tem o token configurado
  const [d4, setD4] = useState({ configurado: false, ambiente: 'sandbox' });
  const [assinaturas, setAssinaturas] = useState([]);

  const carregarAssinaturas = useCallback(() => {
    if (!clienteId) return;
    fetch(`/d4sign/assinaturas?cliente_id=${clienteId}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => setAssinaturas(d.assinaturas || [])).catch(() => {});
  }, [clienteId]);

  useEffect(() => {
    fetch('/d4sign/config', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.json()).then(d => setD4(d || {})).catch(() => {});
    carregarAssinaturas();
  }, [carregarAssinaturas]);

  async function enviarAssinatura() {
    const email = (form.email || '').trim();
    const whats = (form.telefone || '').replace(/\D/g, '');
    if (!email && !whats) return alert('O cliente precisa ter e-mail ou telefone no cadastro pra receber o convite de assinatura.');
    const quem = form.nome || form.razao_social || 'o cliente';
    if (!window.confirm(`Enviar "${modelo === 'contrato' ? 'Contrato' : 'Procuração'}" pra ${quem} assinar digitalmente?\n\nConvite vai para: ${email || ''}${email && whats ? ' e ' : ''}${whats ? 'WhatsApp ' + whats : ''}`)) return;
    setGerando('assinatura');
    try {
      const r = await fetch('/d4sign/enviar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({
          tipo: modelo, dados: campos, cliente_id: clienteId,
          signatario: { nome: quem, email, whatsapp: whats, cpf: form.cpf || campos.cpf_representante || campos.cpf || '' },
        }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Falha no envio');
      alert('✅ Enviado! O cliente recebe o convite pra assinar. Quando assinar, o PDF assinado entra sozinho na aba Upload e você é avisado no WhatsApp.');
      carregarAssinaturas();
    } catch (e) { alert('Erro ao enviar para assinatura: ' + e.message); }
    finally { setGerando(null); }
  }

  async function conferirAssinatura(id) {
    try {
      const r = await fetch(`/d4sign/assinaturas/${id}/conferir`, { method: 'POST', headers: { Authorization: `Bearer ${token()}` } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'falhou');
      alert(d.status === 'assinado' ? '✅ Assinado! O PDF já está na aba Upload.' : `Situação na D4Sign: ${d.status}`);
      carregarAssinaturas();
    } catch (e) { alert('Não consegui conferir: ' + e.message); }
  }

  function selecionarModelo(key) {
    setModelo(key);
    setCampos({ tipo: 'cnpj', assinatura: 'com', ...preencherComCliente(key, form) });
    setPronto(false);
  }

  async function gerar(formato) {
    setGerando(formato);
    try {
      const res = await fetch(`/documentos/${formato}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ tipo: modelo, dados: campos }),
      });
      if (!res.ok) { const d = await res.json(); throw new Error(d.erro || 'Erro'); }
      const blob = await res.blob();
      const ext = formato === 'pdf' ? 'pdf' : 'docx';
      // Nome do arquivo no MESMO padrão do Gerador de Arquivos:
      // "Contrato FULANO.pdf", não "contrato.pdf"
      const quem = (modelo === 'contrato' ? campos.nome_contratante
        : modelo === 'procuracao_cnpj' ? campos.nome_empresa : campos.nome) || form.nome || '';
      const prefixo = modelo === 'contrato' ? 'Contrato' : 'Procuração';
      const url = URL.createObjectURL(new Blob([blob]));
      const a = document.createElement('a');
      a.href = url; a.download = `${prefixo}${quem ? ' ' + quem : ''}.${ext}`.replace(/[\\/:*?"<>|]/g, '');
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch (e) { alert('Erro: ' + e.message); }
    finally { setGerando(null); }
  }

  const inpDoc = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };

  return (
    <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '10px 14px' }}>
      <SectionHeader>Selecione o Documento</SectionHeader>

      {/* Cards de modelo */}
      <div style={{ display: 'flex', gap: 10, margin: '10px 0 14px' }}>
        {MODELOS_DOC.map(m => (
          <div key={m.key} onClick={() => selecionarModelo(m.key)}
            style={{
              flex: 1, background: modelo === m.key ? '#0a1628' : '#f8fafc',
              border: `2px solid ${modelo === m.key ? '#0a1628' : '#c8d0da'}`,
              borderRadius: 6, padding: '10px 12px', cursor: 'pointer', textAlign: 'center',
            }}>
            <div style={{ fontSize: 22, marginBottom: 4 }}>{m.icone}</div>
            <div style={{ fontSize: 12, fontWeight: 700, color: modelo === m.key ? '#fff' : '#0a1628' }}>{m.label}</div>
          </div>
        ))}
      </div>

      {/* Campos do modelo selecionado */}
      {modelo && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8, marginBottom: 2 }}>
            <SectionHeader style={{ margin: 0, flex: 1 }}>Dados do Documento</SectionHeader>
            <button type="button"
              onClick={() => setCampos(prev => ({ ...prev, ...preencherComCliente(modelo, form) }))}
              style={{ background: '#0a1628', color: '#fff', padding: '4px 12px', fontSize: 12, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', marginLeft: 10 }}>
              ⬇ Preencher com dados do cliente
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 6 }}>
            {CAMPOS_DOC[modelo].map(c => (
              <div key={c.name} style={{ gridColumn: c.full ? '1 / -1' : 'auto' }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>
                  {c.label}{c.required && <span style={{ color: '#dc2626' }}> *</span>}
                </label>
                {c.tipo === 'select' ? (
                  <select value={campos[c.name] || ''} onChange={e => setCampos(p => ({ ...p, [c.name]: e.target.value }))}
                    style={{ ...inpDoc, padding: '2px 4px', height: 26 }}>
                    {c.opcoes.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                ) : (
                  <input type={c.type || 'text'} value={campos[c.name] || ''}
                    onChange={e => setCampos(p => ({ ...p, [c.name]: e.target.value }))}
                    placeholder={c.placeholder} required={c.required} style={inpDoc} />
                )}
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
            <button type="button" onClick={() => setPronto(true)}
              style={{ background: '#0a1628', color: '#fff', padding: '5px 16px', fontSize: 13, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
              Preparar documento
            </button>
            <button type="button" onClick={() => { setModelo(null); setPronto(false); }}
              style={{ background: '#f3f4f6', color: '#374151', padding: '5px 14px', fontSize: 13, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>
              Cancelar
            </button>
          </div>

          {pronto && (
            <div style={{ marginTop: 12, padding: '10px 14px', background: '#f0fdf4', borderRadius: 6, border: '1px solid #bbf7d0', display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#16a34a' }}>✅ Pronto! Escolha o formato:</span>
              <button type="button" onClick={() => gerar('word')} disabled={!!gerando}
                style={{ background: '#1d4ed8', color: '#fff', padding: '5px 14px', fontSize: 13, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                {gerando === 'word' ? '⏳...' : '📝 Word'}
              </button>
              <button type="button" onClick={() => gerar('pdf')} disabled={!!gerando}
                style={{ background: '#dc2626', color: '#fff', padding: '5px 14px', fontSize: 13, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer' }}>
                {gerando === 'pdf' ? '⏳...' : '📄 PDF'}
              </button>
              {/* 🖊️ Assinatura digital: o cliente assina pelo celular e o PDF
                  assinado volta sozinho pra aba Upload deste cadastro */}
              <button type="button" onClick={enviarAssinatura} disabled={!!gerando || !d4.configurado}
                title={d4.configurado
                  ? 'Envia pro cliente assinar digitalmente (D4Sign) — o assinado volta sozinho pro cadastro'
                  : 'D4Sign ainda não configurado: falta cadastrar o token da API no servidor'}
                style={{ background: d4.configurado ? '#7c3aed' : '#e5e7eb', color: d4.configurado ? '#fff' : '#9ca3af', padding: '5px 14px', fontSize: 13, fontWeight: 600, borderRadius: 4, border: 'none', cursor: d4.configurado ? 'pointer' : 'not-allowed' }}>
                {gerando === 'assinatura' ? '⏳ Enviando...' : '🖊️ Enviar para assinar'}
              </button>
              {!d4.configurado && <span style={{ fontSize: 11, color: '#9ca3af' }}>assinatura digital pendente de configuração</span>}
              {d4.configurado && d4.ambiente === 'sandbox' && <span style={{ fontSize: 11, color: '#b45309' }}>modo teste (sandbox)</span>}
            </div>
          )}
        </>
      )}

      {/* Assinaturas deste cliente */}
      {assinaturas.length > 0 && (
        <div style={{ marginTop: 14, borderTop: '1px solid #e8eaed', paddingTop: 10 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', marginBottom: 6 }}>🖊️ Assinaturas digitais</div>
          {assinaturas.map(a => {
            const cor = a.status === 'assinado' ? '#15803d' : a.status === 'cancelado' ? '#b91c1c' : '#b45309';
            const rot = a.status === 'assinado' ? '✅ Assinado' : a.status === 'cancelado' ? '🚫 Cancelado' : a.status === 'assinando' ? '✍️ Assinando' : '⏳ Aguardando assinatura';
            return (
              <div key={a._id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', borderBottom: '1px solid #f3f4f6', fontSize: 12.5, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 600, color: '#0a1628', flex: 1, minWidth: 160 }}>{a.nome_documento}</span>
                <span style={{ color: '#6b7280' }}>{a.signatario?.email || a.signatario?.whatsapp || ''}</span>
                <span style={{ color: cor, fontWeight: 700 }}>{rot}</span>
                {a.status !== 'assinado' && a.status !== 'cancelado' && (
                  <button type="button" onClick={() => conferirAssinatura(a._id)}
                    title="Perguntar agora à D4Sign se já assinaram"
                    style={{ background: '#fff', border: '1px solid #d1d5db', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer', color: '#374151' }}>🔄 conferir</button>
                )}
              </div>
            );
          })}
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 5 }}>Quando o cliente assinar, o PDF assinado entra sozinho na aba <b>Upload</b> deste cadastro e você recebe um aviso no WhatsApp.</div>
        </div>
      )}
    </div>
  );
}

// ── Aba Upload ───────────────────────────────────────────────────────────────
function AbaUpload({ clienteId }) {
  const [arquivos, setArquivos] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [erroUpload, setErroUpload] = useState('');
  const inputRef = React.useRef();

  function fmtTamanho(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function fmtData(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('pt-BR');
  }

  async function carregar() {
    if (!clienteId) return;
    try {
      const res = await fetch(`/uploads/cliente/${clienteId}`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      const data = await res.json();
      setArquivos(Array.isArray(data) ? data.sort((a, b) => new Date(b.data) - new Date(a.data)) : []);
    } catch {}
  }

  useEffect(() => { carregar(); }, [clienteId]);

  async function enviarArquivos(files) {
    if (!clienteId) { setErroUpload('Salve o cliente antes de fazer upload.'); return; }
    if (!files || files.length === 0) return;
    setEnviando(true);
    setErroUpload('');
    const fd = new FormData();
    Array.from(files).forEach(f => fd.append('arquivos', f));
    try {
      const res = await fetch(`/uploads/cliente/${clienteId}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token()}` },
        body: fd,
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.erro || `Erro ${res.status}`);
      }
      await carregar();
    } catch (e) { setErroUpload('Erro ao enviar: ' + e.message); }
    finally { setEnviando(false); }
  }

  async function excluir(filename) {
    if (!window.confirm('Excluir este arquivo?')) return;
    await fetch(`/uploads/cliente/${clienteId}/${filename}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token()}` },
    });
    await carregar();
  }

  async function baixar(filename, nome) {
    try {
      const res = await fetch(`/uploads/cliente/${clienteId}/${filename}`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      if (!res.ok) throw new Error(`Erro ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = nome;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch (e) { setErroUpload('Erro ao baixar: ' + e.message); }
  }

  // ── Pré-visualização ──────────────────────────────────────────────
  // O arquivo chega por fetch autenticado (blob) e o navegador renderiza
  // sozinho: imagem, PDF, áudio e vídeo. O resto oferece só o download.
  const [preview, setPreview] = useState(null); // { nome, url, tipo, arquivo }
  const [carregandoPrev, setCarregandoPrev] = useState('');

  function tipoPreview(nome, mime = '') {
    const ext = (nome.split('.').pop() || '').toLowerCase();
    if (mime.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(ext)) return 'imagem';
    if (mime === 'application/pdf' || ext === 'pdf') return 'pdf';
    if (mime.startsWith('audio/') || ['mp3', 'ogg', 'wav', 'opus', 'm4a'].includes(ext)) return 'audio';
    if (mime.startsWith('video/') || ['mp4', 'webm', 'mov'].includes(ext)) return 'video';
    return '';
  }

  async function visualizar(arq) {
    setCarregandoPrev(arq.arquivo);
    try {
      const res = await fetch(`/uploads/cliente/${clienteId}/${arq.arquivo}`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      if (!res.ok) throw new Error(`Erro ${res.status}`);
      const blob = await res.blob();
      const tipo = tipoPreview(arq.nome, blob.type);
      setPreview({ nome: arq.nome, arquivo: arq.arquivo, tipo, url: URL.createObjectURL(blob) });
    } catch (e) { setErroUpload('Erro ao abrir: ' + e.message); }
    setCarregandoPrev('');
  }

  function fecharPreview() {
    if (preview?.url) URL.revokeObjectURL(preview.url);
    setPreview(null);
  }

  // Baixa TODOS os documentos do cliente num ZIP só
  const [baixandoTudo, setBaixandoTudo] = useState(false);
  async function baixarTudo() {
    setBaixandoTudo(true);
    try {
      const res = await fetch(`/uploads/cliente/${clienteId}/zip`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.erro || `Erro ${res.status}`);
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = 'documentos_cliente.zip';
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch (e) { setErroUpload('Erro ao baixar o lote: ' + e.message); }
    setBaixandoTudo(false);
  }

  return (
    <div style={{ background: '#fff', border: '1px solid #c8d0da', borderTop: 'none', padding: '14px 16px' }}>
      {preview && (
        <div onClick={fecharPreview} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 1400, padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, width: preview.tipo === 'pdf' ? 'min(900px, 96vw)' : 'auto', maxWidth: '96vw', maxHeight: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderBottom: '1px solid #e5e7eb' }}>
              <div style={{ flex: 1, fontSize: 13, fontWeight: 700, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{preview.nome}</div>
              <button type="button" onClick={() => baixar(preview.arquivo, preview.nome)}
                style={{ background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>Baixar</button>
              <button type="button" onClick={fecharPreview}
                style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280', padding: '0 2px' }}>✕</button>
            </div>
            <div style={{ overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', minHeight: 120 }}>
              {preview.tipo === 'imagem' && <img src={preview.url} alt={preview.nome} style={{ maxWidth: '94vw', maxHeight: '80vh', display: 'block' }} />}
              {preview.tipo === 'pdf' && <iframe title={preview.nome} src={preview.url} style={{ width: '100%', height: '80vh', border: 'none', background: '#fff' }} />}
              {preview.tipo === 'audio' && <audio src={preview.url} controls autoPlay style={{ margin: 24, width: 'min(420px, 80vw)' }} />}
              {preview.tipo === 'video' && <video src={preview.url} controls autoPlay style={{ maxWidth: '94vw', maxHeight: '80vh' }} />}
              {!preview.tipo && (
                <div style={{ padding: 28, fontSize: 13, color: '#6b7280', textAlign: 'center' }}>
                  Este formato não tem pré-visualização no navegador.<br />Use o botão <b>Baixar</b> pra abrir no aplicativo certo.
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <SectionHeader>Documentos do Cliente</SectionHeader>

      {erroUpload && (
        <div style={{ marginTop: 8, background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 6, padding: '8px 12px', fontSize: 13, color: '#dc2626', fontWeight: 600 }}>
          ⚠ {erroUpload}
        </div>
      )}

      {/* Zona de drop */}
      <div
        onDragOver={e => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={e => { e.preventDefault(); setDragOver(false); enviarArquivos(e.dataTransfer.files); }}
        onClick={() => inputRef.current?.click()}
        style={{
          marginTop: 10, border: `2px dashed ${dragOver ? '#0a1628' : '#c8d0da'}`,
          borderRadius: 8, padding: '28px 16px', textAlign: 'center', cursor: 'pointer',
          background: dragOver ? '#f0f4ff' : '#fafbfc', transition: 'all 0.15s',
        }}
      >
        <div style={{ fontSize: 32, marginBottom: 6 }}>📁</div>
        <div style={{ fontSize: 13, color: '#374151', fontWeight: 600 }}>
          {enviando ? 'Enviando...' : 'Arraste arquivos aqui ou clique para selecionar'}
        </div>
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>Qualquer formato · Máx. 50 MB por arquivo</div>
        <input ref={inputRef} type="file" multiple style={{ display: 'none' }}
          onChange={e => enviarArquivos(e.target.files)} />
      </div>

      {!clienteId && (
        <div style={{ marginTop: 10, fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>
          Salve o cliente primeiro para habilitar o upload.
        </div>
      )}

      {/* Lista de arquivos */}
      {arquivos.length > 0 && (
        <div style={{ marginTop: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
            <SectionHeader>Arquivos enviados ({arquivos.length})</SectionHeader>
            <button type="button" onClick={baixarTudo} disabled={baixandoTudo}
              title="Baixa todos os documentos deste cliente num único arquivo ZIP"
              style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 600, whiteSpace: 'nowrap', opacity: baixandoTudo ? .6 : 1 }}>
              {baixandoTudo ? 'Compactando…' : `📦 Baixar tudo (${arquivos.length})`}
            </button>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {arquivos.map((arq, i) => (
              <div key={arq.arquivo} style={{
                display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px',
                background: i % 2 === 0 ? '#fafafa' : '#fff',
                borderBottom: '1px solid #eee',
              }}>
                <span style={{ fontSize: 18 }}>{{ imagem: '🖼️', pdf: '📕', audio: '🎙️', video: '🎬' }[tipoPreview(arq.nome)] || '📄'}</span>
                <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => visualizar(arq)} title="Clique pra pré-visualizar">
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{arq.nome}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>{fmtTamanho(arq.tamanho)} · {fmtData(arq.data)}</div>
                </div>
                <button type="button" onClick={() => visualizar(arq)} disabled={carregandoPrev === arq.arquivo}
                  title={tipoPreview(arq.nome) ? 'Pré-visualizar sem baixar' : 'Formato sem pré-visualização — abre o aviso'}
                  style={{ background: '#fff', color: '#0a1628', border: '1px solid #c8d0da', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600, opacity: carregandoPrev === arq.arquivo ? .5 : 1 }}>
                  {carregandoPrev === arq.arquivo ? '…' : '👁 Ver'}
                </button>
                <button type="button" onClick={() => baixar(arq.arquivo, arq.nome)}
                  style={{ background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
                  Baixar
                </button>
                <button type="button" onClick={() => excluir(arq.arquivo)}
                  style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
                  Excluir
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {arquivos.length === 0 && clienteId && (
        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 12, color: '#9ca3af' }}>
          Nenhum arquivo enviado ainda.
        </div>
      )}
    </div>
  );
}

// ── Linha densa de campos para Processos ────────────────────────────────────
function PRow({ label, value, onChange, placeholder, extra, full, acao }) {
  const allFields = [{ label, value, onChange, placeholder }, ...(extra || [])];
  return (
    <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e8eaed', padding: '3px 0', gap: 0 }}>
      {allFields.map((field, i) => (
        <React.Fragment key={i}>
          {i > 0 && <div style={{ width: 1, background: '#e8eaed', alignSelf: 'stretch', margin: '0 6px' }} />}
          <div style={{ display: 'flex', alignItems: 'center', flex: full && i === 0 ? 3 : 1, minWidth: 0, gap: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#374151', whiteSpace: 'nowrap', paddingRight: 4, flexShrink: 0 }}>{field.label}:</span>
            <input value={field.value || ''} onChange={e => field.onChange(e.target.value)} placeholder={field.placeholder || ''}
              style={{ width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', height: 26, boxSizing: 'border-box', background: '#fff' }} />
            {i === 0 && acao && (
              <button type="button" onClick={acao.onClick} title={acao.title}
                style={{ flexShrink: 0, background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8', borderRadius: 4, padding: '2px 8px', fontSize: 12, fontWeight: 700, cursor: 'pointer', height: 26 }}>
                {acao.rotulo}
              </button>
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

function SectionHeader({ children, style }) {
  return (
    <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2, ...style }}>
      {children}
    </div>
  );
}

function BtnPrimary({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#0a1628', color: '#fff', padding: '5px 16px', fontSize: 13, fontWeight: 600, borderRadius: 4, border: 'none', cursor: 'pointer', ...(props.style || {}) }}>
      {children}
    </button>
  );
}

function BtnSecondary({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#e8edf2', color: '#0a1628', padding: '5px 16px', fontSize: 13, fontWeight: 600, borderRadius: 4, border: '1px solid #0a1628', cursor: 'pointer' }}>
      {children}
    </button>
  );
}

function BtnCancel({ children, ...props }) {
  return (
    <button {...props} style={{ background: '#f3f4f6', color: '#374151', padding: '5px 14px', fontSize: 13, borderRadius: 4, border: '1px solid #d1d5db', cursor: 'pointer' }}>
      {children}
    </button>
  );
}
